import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { getQuarter } from 'date-fns';
import { MobileDatePickerProps } from './MobileDatePicker';
import { mobileQuarterPickerStyles } from './MobileQuarterPicker.styles';

const MobileQuarterPicker = (props: MobileDatePickerProps) => {
  const { startDate, endDate, selectedDay, setActiveDate, closeCalendarModal } = props;

  const currentDate = selectedDay || new Date();

  // Generate years range based on min/max dates
  const minYear = startDate ? startDate.getFullYear() : currentDate.getFullYear() - 2;
  const maxYear = endDate ? endDate.getFullYear() : currentDate.getFullYear() + 2;

  const years = [];
  for (let year = minYear; year <= maxYear; year++) {
    years.push(new Date(year, 0, 1));
  }

  const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];

  const onQuarterClick = (year: number, quarterIndex: number) => {
    // Create date for the first month of the quarter
    const quarterStartMonth = quarterIndex * 3; // Q1=0, Q2=3, Q3=6, Q4=9
    const newDate = new Date(year, quarterStartMonth, 1);
    setActiveDate?.(newDate);
    closeCalendarModal?.();
  };

  const isQuarterSelected = (year: number, quarterIndex: number) => {
    const currentQuarter = getQuarter(currentDate);
    const currentYear = currentDate.getFullYear();
    return year === currentYear && quarterIndex + 1 === currentQuarter;
  };

  const isQuarterDisabled = (year: number, quarterIndex: number) => {
    const quarterStartMonth = quarterIndex * 3;
    const quarterStart = new Date(year, quarterStartMonth, 1);
    const quarterEnd = new Date(year, quarterStartMonth + 2, 31); // Last day of quarter's last month

    if (startDate && quarterEnd < startDate) return true;
    if (endDate && quarterStart > endDate) return true;
    return false;
  };

  return (
    <Box sx={mobileQuarterPickerStyles.wrapper} data-id={'OuterWrapper'}>
      {years.map(yearDate => {
        const year = yearDate.getFullYear();
        return (
          <Box key={year} sx={mobileQuarterPickerStyles.yearContainer}>
            <Typography sx={mobileQuarterPickerStyles.yearHeader}>{year}</Typography>
            <Box sx={mobileQuarterPickerStyles.quartersGrid}>
              {quarters.map((quarterName, quarterIndex) => {
                const isSelected = isQuarterSelected(year, quarterIndex);
                const isDisabled = isQuarterDisabled(year, quarterIndex);

                return (
                  <Box key={quarterIndex} sx={mobileQuarterPickerStyles.quarterGridItem}>
                    <Button
                      variant="text"
                      disabled={isDisabled}
                      onClick={() => onQuarterClick(year, quarterIndex)}
                      sx={
                        isSelected
                          ? mobileQuarterPickerStyles.selectedQuarterButton
                          : mobileQuarterPickerStyles.quarterButton
                      }
                      fullWidth>
                      {quarterName}
                    </Button>
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default MobileQuarterPicker;
